import { render, staticRenderFns } from "./TopVendorsPortlet.vue?vue&type=template&id=591d3d2f&scoped=true"
import script from "./TopVendorsPortlet.vue?vue&type=script&lang=js"
export * from "./TopVendorsPortlet.vue?vue&type=script&lang=js"
import style0 from "./TopVendorsPortlet.vue?vue&type=style&index=0&id=591d3d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d3d2f",
  null
  
)

export default component.exports